async function isIndexDbSupported() {
  return await new Promise(function (resolve, reject) {
    let request = window.indexedDB.open("TestName", 1);
    request.onerror = (e) => {
      resolve(false);
    };
    request.onsuccess = (e) => {
      resolve(true);
    };
    request.onupgradeneeded = (e) => {
      resolve(true);
    };
  });
}
export { isIndexDbSupported };


// WEBPACK FOOTER //
// ./src/services/helper.js